import { React, useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router';

import axios from 'axios';
import { Global } from '../../Global';

import '../../../assets/css/nuevoRegistro.css';

import Loading from '../../elementos/Loading';
import HeaderVista from '../../elementos/HeaderVista';
import TituloMini from '../../elementos/TituloMini';
import Error from '../../elementos/Error';
import TextEditor from '../../elementos/TextEditor';
import SwitchInput from '../../elementos/SwitchInput';
import Input from '../../elementos/Input';

import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';


import CheckIcon from '@mui/icons-material/Check';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';


export default function ClienteEditTerminosyCondiciones() {

    const [estadoVista, setEstadoVista] = useState('loading');

    const [dominio, setDominio] = useState('');

    const [activo, setActivo] = useState(false);
    const [mensaje, setMensaje] = useState('');
    const [boton, setBoton] = useState('');


    const urlParams = useParams();
    const navigate = useNavigate();

    useEffect(() => {

        axios.get(Global.url_api + 'cliente/' + urlParams.id, { headers: { Authorization: localStorage.getItem("token") } })
            .then(res => {

                setDominio(res.data.dominio);

                setActivo((res.data.terminosycondiciones?.activo ? res.data.terminosycondiciones.activo : false))
                setMensaje((res.data.terminosycondiciones?.mensaje ? res.data.terminosycondiciones.mensaje : ''))
                setBoton((res.data.terminosycondiciones?.boton ? res.data.terminosycondiciones.boton : ''))

                setEstadoVista('cargado');

            })
            .catch((error) => {
                console.log(error?.response?.data);
                setEstadoVista('error')
            });

    }, [urlParams.id]);


    const handleSubmit = (e) => {

        e.preventDefault();

        setEstadoVista('loading');

        let body = {
            activo,
            mensaje,
            boton,
        }

        axios.put(Global.url_api + 'cliente/update/terminosycondiciones/' + dominio, body, { headers: { Authorization: localStorage.getItem("token") } })
            .then(res => {

                navigate('/clientes/' + urlParams.id);

            })
            .catch((error) => {

            });

    }


    if (estadoVista === 'loading') return (<Loading />)

    if (estadoVista === 'error') return (<Error />)

    if (estadoVista === 'cargado')
        return (
            <>
                <HeaderVista
                    volverTo={"/clientes/" + urlParams.id}
                    titulo={"Términos y Condiciones " + dominio}
                />
                <form onSubmit={handleSubmit}>
                    <Container className="nuevoRegistro" component="main" maxWidth="lg">
                        <Grid container spacing={2} >
                            <Grid item xs={12} md={4}>
                                <h4 align="center">Activo</h4>
                                <SwitchInput
                                    label="Activo"
                                    value={activo}
                                    onChange={setActivo}
                                    helperText="Si está prendido, se mostrarán los términos y condiciones."
                                />
                            </Grid>
                            
                            <Grid item xs={12} md={4} >
                                <h4 align="center">Botón</h4>
                                <Input
                                    label="Botón"
                                    icon={<ThumbUpAltIcon />}
                                    value={boton}
                                    onChange={setBoton}
                                    type="text"
                                    helperText="Texto del botón para confirmar"
                                    required
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <br />
                            <Grid item xs={12} >
                                <TituloMini titulo="Términos y Condiciones">Mensaje de términos y condiciones.</TituloMini>
                            </Grid>
                            <Grid item xs={12} md={12} >
                                <TextEditor textoHtml={mensaje} setTextoHtml={setMensaje} />
                            </Grid>

                        </Grid>
                    </Container>
                    <Container className="nuevoRegistro footer" component="main" maxWidth="lg">
                        <Grid container>
                            <Grid className="botones" item xs={12} >
                                <Button type="submit" variant="contained" color="success" startIcon={<CheckIcon />} >
                                    Guardar
                                </Button>
                            </Grid>
                            
                        </Grid>
                    </Container>
                </form>
            </>
        )

}